export default "__VITE_ASSET__sDqxFASy__"